// extracted by mini-css-extract-plugin
export var card = "MobileCard-module--card--dc78a";
export var current = "MobileCard-module--current--653c4";
export var dark = "MobileCard-module--dark--165bf";
export var fadeInAnimation = "MobileCard-module--fadeInAnimation--5fd8b";
export var img = "MobileCard-module--img--8a7eb";
export var innerLayout = "MobileCard-module--innerLayout--45d02";
export var name = "MobileCard-module--name--cc244";
export var picture = "MobileCard-module--picture--a75f8";
export var pictureWrapper = "MobileCard-module--pictureWrapper--d5f98";
export var playIcon = "MobileCard-module--playIcon--6b99f";
export var position = "MobileCard-module--position--14aa1";
export var text = "MobileCard-module--text--bdabb";
export var title = "MobileCard-module--title--dfb9f";